(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wiwify-journey"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.wol-section[data-section-id]');
    if (!root) return;
    var sid = root.dataset.sectionId;
    var notFoundMsg = root.dataset.notFound;
    var errorMsg = root.dataset.error;
    var form = document.getElementById('wol-form-' + sid);
    var input = document.getElementById('wol-input-' + sid);
    var btn = document.getElementById('wol-btn-' + sid);
    var loading = document.getElementById('wol-loading-' + sid);
    var errorEl = document.getElementById('wol-error-' + sid);
    var resultEl = document.getElementById('wol-result-' + sid);
    var ADMIN_KEY = 'ww-admin';

    function showOnly(el) {
      [loading, errorEl, resultEl].forEach(function (e) { e.classList.remove('is-visible'); });
      el.classList.add('is-visible');
    }

    function badgeCls(s) {
      if (s === 'TESLİM EDİLDİ') return 'wol-badge--delivered';
      if (s === 'İPTAL EDİLDİ') return 'wol-badge--cancelled';
      return 'wol-badge--other';
    }

    function badgeLabel(s) {
      if (s === 'TESLİM EDİLDİ') return 'Teslim Edildi';
      if (s === 'İPTAL EDİLDİ') return 'İptal Edildi';
      return 'İşlemde';
    }

    function fmtDate(iso) {
      if (!iso) return '';
      try { return new Date(iso).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' }); }
      catch (e) { return iso; }
    }

    function fmtPrice(val) {
      if (val == null) return '';
      return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(val);
    }

    function fmtNum(n) {
      return new Intl.NumberFormat('tr-TR').format(n);
    }

    function renderItems(items) {
      return items.map(function (item) {
        var img = item.image_url
          ? '<img class="wol-item__img" src="' + item.image_url + '" alt="' + (item.title || '') + '" loading="lazy">'
          : '<div class="wol-item__placeholder"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 7H4C2.9 7 2 7.9 2 9V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V9C22 7.9 21.1 7 20 7Z" fill="#c0bdb8"/><path d="M16 7V5C16 3.9 15.1 3 14 3H10C8.9 3 8 3.9 8 5V7" stroke="#fff" stroke-width="1.5"/></svg></div>';
        var name = item.product_url
          ? '<a href="' + item.product_url + '">' + (item.title || '') + '</a>'
          : (item.title || '');
        var qty = item.quantity + ' adet' + (item.unit_price != null ? ' &nbsp;·&nbsp; ' + fmtPrice(item.unit_price) : '');
        return '<li class="wol-item">' + img + '<div class="wol-item__info"><p class="wol-item__name">' + name + '</p><p class="wol-item__qty">' + qty + '</p></div></li>';
      }).join('');
    }

    function renderResult(data) {
      var o = data.order;
      var html = '<div class="wol-result__card">'
        + '<div class="wol-result__header">'
        + '<div class="wol-result__left">'
        + '<span class="wol-result__number">' + (o.order_number || '') + '</span>'
        + '<span class="wol-result__channel">' + (o.channel || '') + '</span>'
        + '</div>'
        + '<div class="wol-result__meta">'
        + (o.order_date ? '<span class="wol-result__date">' + fmtDate(o.order_date) + '</span>' : '')
        + (o.total_amount != null ? '<span class="wol-result__total">' + fmtPrice(o.total_amount) + '</span>' : '')
        + '<span class="wol-badge ' + badgeCls(o.status) + '">' + badgeLabel(o.status) + '</span>'
        + '</div>'
        + '</div>'
        + '<ul class="wol-items">' + renderItems(o.items || []) + '</ul>'
        + '</div>';
      resultEl.innerHTML = html;
      showOnly(resultEl);
    }

    function renderReport(data) {
      var s = data.summary;
      var html = '<div class="wol-report__header">'
        + '<span class="wol-report__badge">YÖNETİCİ</span>'
        + '<h2 class="wol-report__title">Sipariş Analizi</h2>'
        + '</div>'
        + '<div class="wol-report__summary">'
        + '<div class="wol-stat"><div class="wol-stat__value">' + fmtNum(s.total_orders) + '</div><div class="wol-stat__label">Sipariş</div></div>'
        + '<div class="wol-stat"><div class="wol-stat__value">' + fmtPrice(s.total_revenue) + '</div><div class="wol-stat__label">Ciro</div></div>'
        + '<div class="wol-stat"><div class="wol-stat__value">' + fmtNum(s.total_items) + '</div><div class="wol-stat__label">Satılan Ürün</div></div>'
        + '</div>';

      if (data.channels && data.channels.length) {
        html += '<p class="wol-report__section-title">Kanallara Göre</p>'
          + '<div class="wol-channels">';
        data.channels.forEach(function (c) {
          html += '<div class="wol-channel">'
            + '<div class="wol-channel__name">' + c.channel + '</div>'
            + '<div class="wol-channel__stats">'
            + '<div class="wol-channel__stat"><div class="wol-channel__val">' + fmtNum(c.order_count) + '</div><div class="wol-channel__lbl">Sipariş</div></div>'
            + '<div class="wol-channel__stat"><div class="wol-channel__val">' + fmtPrice(c.revenue) + '</div><div class="wol-channel__lbl">Ciro</div></div>'
            + '<div class="wol-channel__stat"><div class="wol-channel__val">' + fmtNum(c.items_sold) + '</div><div class="wol-channel__lbl">Ürün</div></div>'
            + '</div>'
            + '</div>';
        });
        html += '</div>';
      }

      resultEl.innerHTML = html;
      showOnly(resultEl);
    }

    function fetchReport() {
      btn.disabled = true;
      showOnly(loading);
      fetch('/apps/orders/report')
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(renderReport)
        .catch(function () {
          errorEl.textContent = 'Rapor yüklenirken bir hata oluştu.';
          showOnly(errorEl);
        })
        .finally(function () { btn.disabled = false; });
    }

    if (form) {
      form.addEventListener('submit', function () {
        var val = input.value.trim();
        if (!val) return;
        if (val.toLowerCase() === ADMIN_KEY) {
          fetchReport();
          return;
        }
        btn.disabled = true;
        showOnly(loading);
        fetch('/apps/orders/lookup?order_number=' + encodeURIComponent(val))
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.json();
          })
          .then(function (data) {
            if (!data.found) {
              errorEl.textContent = notFoundMsg;
              showOnly(errorEl);
            } else {
              renderResult(data);
            }
          })
          .catch(function () {
            errorEl.textContent = errorMsg;
            showOnly(errorEl);
          })
          .finally(function () { btn.disabled = false; });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
